import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { FieldError } from "react-hook-form";

export const useFieldErrorMessage = (fieldError: undefined | FieldError): string | undefined => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!fieldError) {
      return fieldError;
    }

    console.log(fieldError.type);

    if (fieldError.type === "email") {
      return t("formErrors.email");
    }

    if (fieldError.type === "trim") {
      return t("formErrors.trim");
    }

    if (fieldError.type === "oneOf") {
      return t("formErrors.invalidSelection");
    }

    if (fieldError.type === "required" || fieldError.type === "nullable") {
      return t("formErrors.required");
    }

    return t("formErrors.invalid");
  }, [fieldError, t]);
};
